import React from "react";

/**
 * React Context for MobX stores.
 * This provides a hook-based alternative to inject() for functional components.
 */
export const StoreContext = React.createContext(null);

/**
 * Custom hook to access MobX stores from functional components.
 * Use this instead of inject() when writing functional components with hooks.
 *
 * @returns {Object} The rootStore with all its nested stores
 *
 * @example
 * const rootStore = useStores();
 * const { authStore, commonStore } = rootStore;
 * const userData = authStore.userData;
 */
export const useStores = () => {
  const store = React.useContext(StoreContext);
  if (!store) {
    throw new Error("useStores must be used within a StoreContext.Provider");
  }
  return store;
};
